import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=2206ebca&scoped=true"
import script from "./preview.vue?vue&type=script&lang=ts"
export * from "./preview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206ebca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2206ebca')) {
      api.createRecord('2206ebca', component.options)
    } else {
      api.reload('2206ebca', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=2206ebca&scoped=true", function () {
      api.rerender('2206ebca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/household/pages/giving/receipt-preview/preview.vue"
export default component.exports